// extracted by mini-css-extract-plugin
export default {"size":"size___MbCOT"};